// From https://github.com/parshap/node-sanitize-filename
// --------

// Illegal Characters on Various Operating Systems
// / ? < > \ : * | "
// https://kb.acronis.com/content/39790
const illegalRe = /[/?<>\\:*|"]/g

// Unicode Control codes
// C0 0x00-0x1f & C1 (0x80-0x9f)
// http://en.wikipedia.org/wiki/C0_and_C1_control_codes
// eslint-disable-next-line no-control-regex
const controlRe = /[\x00-\x1f\x80-\x9f]/g

// Reserved filenames on Unix-based systems (".", "..")
const reservedRe = /^\.+$/

// Reserved filenames in Windows ("CON", "PRN", "AUX", "NUL", "COM1",
// "COM2", "COM3", "COM4", "COM5", "COM6", "COM7", "COM8", "COM9",
// "LPT1", "LPT2", "LPT3", "LPT4", "LPT5", "LPT6", "LPT7", "LPT8", and
// "LPT9") case-insensitively and with or without filename extensions.
const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i
const windowsTrailingRe = /[. ]+$/

// Capped at 255 characters in length.
// http://utruncatednix.stackexchange.com/questions/32795/what-is-the-maximum-allowed-filename-and-folder-size-with-ecryptfs
const truncate = (input: string) => input.split("").splice(0, 255).join("")

type sanitizeOptions = {
	forceAlphanumeric?: boolean
}

export const sanitizeFilename = (
	input: string,
	options: sanitizeOptions = {
		forceAlphanumeric: false,
	}
) => {
	if (typeof input !== "string") {
		throw new Error("Input must be string")
	}

	const fileExtension = input.split(".").pop()

	const sanitized = input
		.replace(fileExtension, "")
		.replace(illegalRe, "")
		.replace(controlRe, "")
		.replace(reservedRe, "")
		.replace(windowsReservedRe, "")
		.replace(windowsTrailingRe, "")
		.replace(/\s+/g, "")

	if (options.forceAlphanumeric) {
		// NB: the regex use the caret ^ for negation: https://www.regular-expressions.info/charclass.html
		return `${truncate(sanitized.replace(/[^\w-]+/g, ""))}.${fileExtension}`
	}

	return `${truncate(sanitized)}.${fileExtension}`
}
